module.exports = __webpack_public_path__ + "img/servicioTalleres.7fd3bb35.jpg";